/* ── ATLANES MANUAL — main.js ───────────────────────────────────────────── */

(function () {
  'use strict';

  const TOTAL_STEPS = 9;
  let currentStep = 1;

  // ── DOM refs ─────────────────────────────────────────────────────────────
  const track       = document.getElementById('stepsTrack');
  const dotsWrap    = document.getElementById('stepsDots');
  const progressFill = document.getElementById('progressFill');
  const progressLabel = document.getElementById('progressLabel');
  const prevBtn     = document.getElementById('prevBtn');
  const nextBtn     = document.getElementById('nextBtn');
  const startBtn    = document.getElementById('startBtn');
  const stepsSection = document.getElementById('steps');

  // ── i18n — lingua del tutorial ───────────────────────────────────────────
  const LANGS = window.ATLANES_LANGS || [{ code: 'it', label: 'Italiano', flag: '🇮🇹' }];
  const I18N  = window.ATLANES_I18N  || {};
  const DEFAULT_LANG = 'it';
  let currentLang = localStorage.getItem('atlanes_lang') || DEFAULT_LANG;
  if (!I18N[currentLang]) currentLang = DEFAULT_LANG;

  const langBtn  = document.getElementById('langBtn');
  const langMenu = document.getElementById('langMenu');
  const langFlag = document.getElementById('langFlag');
  const langCode = document.getElementById('langCode');

  function t(key) {
    const dict = I18N[currentLang] || I18N[DEFAULT_LANG] || {};
    if (key in dict) return dict[key];
    const fb = I18N[DEFAULT_LANG] || {};
    return (key in fb) ? fb[key] : '';
  }

  function applyTranslations() {
    document.documentElement.lang = currentLang;

    document.querySelectorAll('[data-i18n]').forEach(el => {
      const v = t(el.getAttribute('data-i18n'));
      if (v) el.textContent = v;
    });
    document.querySelectorAll('[data-i18n-html]').forEach(el => {
      const v = t(el.getAttribute('data-i18n-html'));
      if (v) el.innerHTML = v;
    });

    const cur = LANGS.find(l => l.code === currentLang);
    if (cur) {
      if (langFlag) langFlag.textContent = cur.flag;
      if (langCode) langCode.textContent = cur.code.toUpperCase();
    }
    if (langMenu) {
      langMenu.querySelectorAll('.lang__opt').forEach(opt => {
        const on = opt.dataset.code === currentLang;
        opt.classList.toggle('active', on);
        opt.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    updateUI(); // riallinea le etichette dei controlli alla lingua scelta
  }

  function buildLangMenu() {
    if (!langMenu) return;
    LANGS.forEach(l => {
      const b = document.createElement('button');
      b.className = 'lang__opt';
      b.type = 'button';
      b.setAttribute('role', 'option');
      b.dataset.code = l.code;
      b.innerHTML = '<span class="lang__opt-flag">' + l.flag + '</span><span class="lang__opt-label">' + l.label + '</span>';
      b.addEventListener('click', () => { setLang(l.code); closeLangMenu(); if (langBtn) langBtn.focus(); });
      langMenu.appendChild(b);
    });
  }

  function setLang(code) {
    if (!I18N[code]) return;
    currentLang = code;
    try { localStorage.setItem('atlanes_lang', code); } catch (e) {}
    applyTranslations();
  }

  function openLangMenu()  { if (langMenu) { langMenu.hidden = false; langBtn.setAttribute('aria-expanded', 'true');  langBtn.classList.add('open'); } }
  function closeLangMenu() { if (langMenu) { langMenu.hidden = true;  langBtn.setAttribute('aria-expanded', 'false'); langBtn.classList.remove('open'); } }
  function toggleLangMenu(){ if (langMenu) { langMenu.hidden ? openLangMenu() : closeLangMenu(); } }

  if (langBtn && langMenu) {
    langBtn.addEventListener('click', e => { e.stopPropagation(); toggleLangMenu(); });
    document.addEventListener('click', e => {
      if (!langMenu.hidden && !langMenu.contains(e.target) && !langBtn.contains(e.target)) closeLangMenu();
    });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeLangMenu(); });
  }

  // ── Build dots ───────────────────────────────────────────────────────────
  function buildDots() {
    for (let i = 1; i <= TOTAL_STEPS; i++) {
      const btn = document.createElement('button');
      btn.className = 'steps-dots__dot' + (i === 1 ? ' active' : '');
      btn.setAttribute('role', 'tab');
      btn.setAttribute('aria-label', `Passo ${i}`);
      btn.setAttribute('aria-selected', i === 1 ? 'true' : 'false');
      btn.dataset.index = i;
      btn.addEventListener('click', () => goTo(i));
      dotsWrap.appendChild(btn);
    }
  }

  // ── Update UI state ──────────────────────────────────────────────────────
  function updateUI() {
    // track slide
    track.style.transform = `translateX(-${(currentStep - 1) * 100}%)`;

    // activate step article
    document.querySelectorAll('.step').forEach((el, i) => {
      el.classList.toggle('active', i + 1 === currentStep);
    });

    // progress bar
    const pct = (currentStep / TOTAL_STEPS) * 100;
    progressFill.style.width = pct + '%';
    progressLabel.textContent = `${currentStep} / ${TOTAL_STEPS}`;

    // dots
    document.querySelectorAll('.steps-dots__dot').forEach((dot, i) => {
      const n = i + 1;
      dot.classList.toggle('active', n === currentStep);
      dot.classList.toggle('done', n < currentStep);
      dot.setAttribute('aria-selected', n === currentStep ? 'true' : 'false');
    });

    // buttons
    prevBtn.disabled = currentStep === 1;

    if (currentStep === TOTAL_STEPS) {
      nextBtn.innerHTML = t('controls.done') + ' <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 8.5l4 4 6-7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      nextBtn.classList.add('btn--done');
    } else {
      nextBtn.innerHTML = t('controls.next') + ' <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3.5 8H12.5M8.5 4L12.5 8L8.5 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      nextBtn.classList.remove('btn--done');
    }
  }

  // ── Navigate ─────────────────────────────────────────────────────────────
  function goTo(n) {
    if (n < 1 || n > TOTAL_STEPS) return;
    currentStep = n;
    updateUI();
  }

  function next() {
    if (currentStep < TOTAL_STEPS) {
      goTo(currentStep + 1);
    } else {
      // scroll to complete section smoothly
      document.getElementById('complete').scrollIntoView({ behavior: 'smooth' });
    }
  }

  function prev() {
    if (currentStep > 1) goTo(currentStep - 1);
  }

  // ── Touch / swipe ────────────────────────────────────────────────────────
  let touchStartX = 0;
  let touchEndX   = 0;

  const viewport = document.getElementById('stepsViewport');
  viewport.addEventListener('touchstart', e => {
    touchStartX = e.changedTouches[0].clientX;
  }, { passive: true });

  viewport.addEventListener('touchend', e => {
    touchEndX = e.changedTouches[0].clientX;
    const delta = touchStartX - touchEndX;
    if (Math.abs(delta) > 50) {
      delta > 0 ? next() : prev();
    }
  }, { passive: true });

  // ── Keyboard ─────────────────────────────────────────────────────────────
  document.addEventListener('keydown', e => {
    // only when steps section is in view
    const rect = stepsSection.getBoundingClientRect();
    const inView = rect.top < window.innerHeight && rect.bottom > 0;
    if (!inView) return;

    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); next(); }
    if (e.key === 'ArrowLeft'  || e.key === 'ArrowUp')   { e.preventDefault(); prev(); }
  });

  // ── Start button ─────────────────────────────────────────────────────────
  if (startBtn) {
    startBtn.addEventListener('click', () => {
      stepsSection.scrollIntoView({ behavior: 'smooth' });
    });
  }

  // ── Controls ─────────────────────────────────────────────────────────────
  nextBtn.addEventListener('click', next);
  prevBtn.addEventListener('click', prev);

  // ── Scroll reveal ─────────────────────────────────────────────────────────
  function initReveal() {
    const targets = document.querySelectorAll(
      '.prereq__card, .section-title, .section-eyebrow, .complete__card, .faq__item, .footer__inner'
    );
    targets.forEach(el => el.classList.add('reveal'));

    const observer = new IntersectionObserver(entries => {
      entries.forEach((entry, i) => {
        if (entry.isIntersecting) {
          // stagger siblings in same parent
          const siblings = Array.from(entry.target.parentNode.querySelectorAll('.reveal'));
          const idx = siblings.indexOf(entry.target);
          setTimeout(() => {
            entry.target.classList.add('visible');
          }, idx * 80);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    targets.forEach(el => observer.observe(el));
  }

  // ── Nav scroll effect ────────────────────────────────────────────────────
  const nav = document.getElementById('nav');
  window.addEventListener('scroll', () => {
    nav.style.background = window.scrollY > 40
      ? 'rgba(0,0,0,0.85)'
      : 'rgba(0,0,0,0.7)';
  }, { passive: true });

  // ── Init ─────────────────────────────────────────────────────────────────
  buildDots();
  buildLangMenu();
  updateUI();
  applyTranslations();

  // activate first step after a short delay (entry animation)
  requestAnimationFrame(() => {
    setTimeout(() => {
      const first = document.querySelector('.step[data-step="1"]');
      if (first) first.classList.add('active');
    }, 100);
  });

  initReveal();

})();
